const bearerToken = token => {
  return `Bearer ${token}`;
};

export default bearerToken;
